export default [
    {
        week: 1,
        day: 1,
        learned: {
            'de': [
                'Was eine Pflanze zum Leben braucht'
            ],
            'en': [
                'What a plant needs'
            ]
        }
    },
    {
        week: 1,
        day: 2,
        learned: {
            'de': [
                'Maschinenbau',
                'Geologie',
                'Chemie'
            ],
            'en': [
                'Mechanical engineering',
                'Geology',
                'Chemistry'
            ]
        }
    },
    {
        week: 1,
        day: 3,
        learned: {
            'de': [
                'Chemische Experimente',
                'Vulkane'
            ],
            'en': [
                'Chemical experiments',
                'Vulcano'
            ]
        }
    },
    {
        week: 1,
        day: 4,
        learned: {
            'de': [
                'Bagger konstruieren',
                'Große Maschinen und Fahrzeuge'
            ],
            'en': [
                'Building a dredger',
                'Big machines and vehicles'
            ]
        }
    },
    {
        week: 1,
        day: 5,
        learned: {
            'de': [
                'Beruf Chemiker / Chemikerin',
                'Beruf Maschinenbauer / Maschinenbauerin',
                'Beruf Geologe / Geologin'
            ],
            'en': [
                'Profession chemist',
                'Profession engineer',
                'Profession geologist'
            ]
        }
    },
    {
        week: 2,
        day: 1,
        learned: {
            'de': [
                'Notrufnummern',
                'Röntgen'
            ],
            'en': [
                'Emergency numbers',
                'X-ray'
            ]
        }
    },
    {
        week: 2,
        day: 2,
        learned: {
            'de': [
                'Das Gehirn',
                'Operationsvorbereitung'
            ],
            'en': [
                'The brain',
                'Surgery preparations'
            ]
        }
    },
    {
        week: 2,
        day: 3,
        learned: {
            'de': [
                'Medizintechnik',
                'Roboter im Operationssaal'
            ],
            'en': [
                'Medical technician',
                'Surgery robot'
            ]
        }
    },
    {
        week: 2,
        day: 4,
        learned: {
            'de': [
                'Roboter Technik'
            ],
            'en': [
                'Robot tech'
            ]
        }
    },
    {
        week: 2,
        day: 5,
        learned: {
            'de': [
                'Medizinische Berufe',
                'Roboter Technik'
            ],
            'en': [
                'Medical professions',
                'Robot tech'
            ]
        }
    },
    {
        week: 3,
        day: 1,
        learned: {
            'de': [
                'Verkehrssysteme',
                'Smart City'
            ],
            'en': [
                'Traffic engineering',
                'Smart City'
            ]
        }
    },
    {
        week: 3,
        day: 2,
        learned: {
            'de': [
                'Strom',
                'E-Autos'
            ],
            'en': [
                'Electricity',
                'E-cars'
            ]
        }
    },
    {
        week: 3,
        day: 3,
        learned: {
            'de': [
                'Nachhaltige Energiequellen',
                'Windenergie',
                'Strom-Netzwerke'
            ],
            'en': [
                'Sustainable Energiequellen',
                'Wind power',
                'Power supply'
            ]
        }
    },
    {
        week: 3,
        day: 4,
        learned: {
            'de': [
                'Energiesparmassnahmen',
                'Gebäudeverbesserung'
            ],
            'en': [
                'Saving enegry',
                'House improvement'
            ]
        }
    },
    {
        week: 3,
        day: 5,
        learned: {
            'de': [
                'Energieberufe'
            ],
            'en': [
                'Electric-Power professions'
            ]
        }
    },
    {
        week: 4,
        day: 1,
        learned: {
            'de': [
                'Motivierende Sprüche',
                'Wie man Daten erfasst'
            ],
            'en': [
                'Motivating sayings',
                'How to collect data'
            ]
        }
    },
    {
        week: 4,
        day: 2,
        learned: {
            'de': [
                'Statistik',
                'Sportwissenschaften',
                'Trainingsgeräte'
            ],
            'en': [
                'Statistics',
                'Sport science',
                'Training equipment'
            ]
        }
    },
    {
        week: 4,
        day: 3,
        learned: {
            'de': [
                'Psychologie',
                'Willenskraft',
                'Mentaltraining'
            ],
            'en': [
                'Psychology',
                'Willpower',
                'Mental training'
            ]
        }
    },
    {
        week: 4,
        day: 4,
        learned: {
            'de': [
                'Prothesen',
                'Durchhaltevermögen',
                'Staffellauf'
            ],
            'en': [
                'Prosthesis',
                'Performance',
                'Relay race'
            ]
        }
    },
    {
        week: 4,
        day: 5,
        learned: {
            'de': [
                'Sport- & Technikberufe'
            ],
            'en': [
                'Sport an technical professions'
            ]
        }
    }
];
